import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useSelector } from "react-redux";
import { api } from "../utils/hostname";
import config from "../url/config";
import { SplitServiceMeResponseT } from "../types/splitService";
import { useGetLoyaltyUser } from "./useGetLoyaltyUser";
import * as authSelectors from "../redux/auth/selectors";

const request = () => api(true, true).get(config.api.splitService.me);

export const useSplitServiceData = () => {
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  const {
    data,
    isPending: isPendingLoyalty,
    isLoading: isLoadingLoyalty,
  } = useQuery<AxiosResponse<SplitServiceMeResponseT>>({
    queryKey: ["split-service me"],
    queryFn: request,
    staleTime: 5 * 50 * 1000,
    retry: 1,
    enabled: !!isAuthenticated,
  });

  const {
    data: loyaltyData,
    isPending: isPendingLoyaltyUser,
    isLoading: isLoadingLoyaltyUser,
  } = useGetLoyaltyUser();
  const loyaltyIsEmpty =
    loyaltyData?.data?.data && Object.keys(loyaltyData.data.data).length === 0;

  return {
    loyaltyAccess:
      !!isAuthenticated &&
      data?.data?.data?.group === 1 &&
      !loyaltyIsEmpty &&
      VITE_APP_PROJECT_NAME === "glory",
    isPendingLoyalty:
      isPendingLoyalty ||
      isPendingLoyaltyUser ||
      isLoadingLoyalty ||
      isLoadingLoyaltyUser,
  };
};
